/*! Ardor Printing real estate sign 3D preview v1.0.0 (window.ArdorRealestate3D).
 * Needs global THREE (r147) and THREE.OrbitControls loaded first. No other files, no network loads.
 * Units are inches, y up, the ground is y = 0, the print's front faces +z. Each face texture is the WHOLE template page
 * as printed; only the piece's `visible` rect is shown (hardware covers the edges, hidden islands are painted over). */
(function (root) {
  "use strict";

  var FOV = 28, EL_MAX = 1.45, EL_MIN = 0.02, DEFAULT_BG = "#f4f6f5", PI = Math.PI,
    FILL_HOME = 0.9, FILL_NEAR = 0.97, FILL_FAR = 0.45;
  // camera views: [azimuth (0 = front, +PI/2 = right side), elevation]
  var VIEWS = {
    home: [0.5, 0.14], front: [0, 0.06], back: [PI, 0.06], side: [1.05, 0.12],
    left: [-PI / 2, 0.06], right: [PI / 2, 0.06], top: [0, 1.4]
  };
  var PREFIX = { YS: "yard", RA: "aframe", RP: "post", RF: "frame" },
    COVER = { yard: "#f4f4f1", aframe: "#1d1e21", post: "#c3c8cd", frame: "#1d1e21" }, // paint for hidden islands
    FACES = ["front", "back", "rider-front", "rider-back"],
    // modelling defaults (inches) = the specs' hardware.model numbers; a passed hardware.model overrides them
    MODEL = {
      yard: { wireDia: 0.16, legSpacing: 10, insertIntoSign: 10, crossbarBelowSign: 8.5, inGround: 11.5, totalHeight: 30 },
      aframe: { topBarWidth: 27, heightToTopBar: 31, handleRise: 2.5, handleWidth: 13, footSpread: 20, wireDia: 0.25, signTopBelowTopBar: 1, poleAboveTopBar: 18, flagW: 14, flagH: 8 },
      post: { postSize: 4, postHeight: 72, armLength: 38, armSize: 3.5, armBackOverhang: 1.6, armTopFromGround: 65.5, signGapFromPost: 4, signTopBelowArm: 1.5 },
      postL: { postSize: 4, postHeight: 72, armLength: 52, armSize: 3.5, armBackOverhang: 1.6, armTopFromGround: 65.5, signGapFromPost: 4.5, signTopBelowArm: 1.5 },
      frame: { tube: 0.6, innerWidth: 24.05, signTop: 0.3, midBarY: 18.4, riderTop: 19, lowBarY: 25.2, stepTabY: 33, stepTabLen: 1.2, legBottom: 43, sink: 9 }
    };

  function hasThree() {
    var T = root.THREE;
    return !!(T && T.WebGLRenderer && T.OrbitControls && T.BufferGeometry && T.MeshLambertMaterial && T.MeshPhongMaterial &&
      T.CanvasTexture && T.CylinderGeometry && T.BoxGeometry && T.TubeGeometry && T.CatmullRomCurve3 && T.CurvePath &&
      T.LineCurve3 && T.SphereGeometry && T.PlaneGeometry && T.Box3);
  }

  function create(host, opts) {
    try { return !host || !hasThree() ? null : build(host, opts || {}); } catch (e) {
      try { // clean up a half-built viewer so the page can fall back to 2D
        var cs = host.querySelectorAll("canvas[data-ardor-realestate3d='init']"), i, gl, ext;
        for (i = 0; i < cs.length; i++) {
          gl = cs[i].getContext("webgl2") || cs[i].getContext("webgl");
          ext = gl && gl.getExtension("WEBGL_lose_context");
          if (ext) ext.loseContext();
          if (cs[i].parentNode) cs[i].parentNode.removeChild(cs[i]);
        }
      } catch (e2) { }
      return null;
    }
  }

  /* ---------- input helpers (lenient: specs JSON or Shopify option text) ---------- */
  function num(v, lo, hi) {
    var n = Number(v);
    return v !== null && v !== "" && v !== true && v !== false && isFinite(n) && n >= lo && n <= hi ? n : null;
  }
  function str(v) { return v === null || v === undefined || typeof v === "object" ? "" : String(v).toLowerCase().replace(/^\s+|\s+$/g, ""); }
  function keyOf(v) { return typeof v === "string" ? v.replace(/^\s+|\s+$/g, "") : ""; }
  function obj(v) { return v && typeof v === "object" ? v : {}; }
  function lst(v) { return v && typeof v === "object" && typeof v.length === "number" ? v : []; }
  function bgColor(v) { return typeof v === "string" && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v.trim()) ? v.trim() : DEFAULT_BG; }
  function arr(v, n) {
    if (!v || typeof v !== "object" || typeof v.length !== "number" || v.length < n) return null;
    var o = [], i, x;
    for (i = 0; i < n; i++) { x = Number(v[i]); if (v[i] === null || v[i] === "" || !isFinite(x)) return null; o.push(x); }
    return o;
  }
  function rectOf(h) { return h && typeof h === "object" ? arr(h.rect, 4) || arr(h, 4) : null; }
  function inter(a, b) {
    var x0 = Math.max(a[0], b[0]), y0 = Math.max(a[1], b[1]), x1 = Math.min(a[0] + a[2], b[0] + b[2]), y1 = Math.min(a[1] + a[3], b[1] + b[3]);
    return x1 - x0 > 0.02 && y1 - y0 > 0.02 ? [x0, y0, x1 - x0, y1 - y0] : null;
  }
  function clampRect(r, t) { return r ? (r = inter(r, [0, 0, t.w, t.h])) && r[2] >= 1 && r[3] >= 1 ? r : null : null; }
  function sizeOf(s) { var m = /(\d+(?:\.\d+)?)\s*["”]?\s*x\s*(\d+(?:\.\d+)?)/i.exec(s || ""); return m ? [+m[1], +m[2]] : null; }
  function truthy(v) { return v === true || /^(yes|y|true|1|on|with|add|pennant|flag)/.test(str(v)); }
  function noneish(v) { return v === false || /^(no|none|n|0|false|off|without|sign only|no stake|no rider)$/.test(str(v)); }
  function famOf(v, key) {
    var s = str(v);
    if (s) {
      if (/a[\s-]?frame/.test(s)) return "aframe";
      if (/post/.test(s)) return "post";
      if (/frame/.test(s)) return "frame";
      if (/yard|h-?stake|coroplast|lawn/.test(s)) return "yard";
    }
    return PREFIX[key.slice(0, 2).toUpperCase()] || null;
  }
  // hidden strips that overlap the visible rect along a whole edge are trimmed off it
  function trimVis(v, hid) {
    v = v.slice();
    for (var i = 0; i < hid.length && i < 40; i++) {
      var r = rectOf(hid[i]);
      if (!r || r[2] <= 0 || r[3] <= 0) continue;
      var x1 = v[0] + v[2], y1 = v[1] + v[3], rx = r[0] + r[2], ry = r[1] + r[3];
      if (r[0] <= v[0] + 0.05 && rx >= x1 - 0.05) {
        if (r[1] <= v[1] + 0.05 && ry > v[1] && ry < y1 - 1) { v[3] = y1 - ry; v[1] = ry; }
        else if (ry >= y1 - 0.05 && r[1] < y1 && r[1] > v[1] + 1) v[3] = r[1] - v[1];
      } else if (r[1] <= v[1] + 0.05 && ry >= y1 - 0.05) {
        if (r[0] <= v[0] + 0.05 && rx > v[0] && rx < x1 - 1) { v[2] = x1 - rx; v[0] = rx; }
        else if (rx >= x1 - 0.05 && r[0] < x1 && r[0] > v[0] + 1) v[2] = r[0] - v[0];
      }
    }
    return v;
  }
  // one printed piece (sign or rider): template, visible rect, hidden islands left inside it, holes, faces
  function piece(p, def, two) {
    var tw = p.tpl ? num(p.tpl.w, 1, 200) : null, th = p.tpl ? num(p.tpl.h, 1, 200) : null,
      tpl = tw && th ? { w: tw, h: th } : { w: def[0], h: def[1] }, hid = lst(p.hidden), hl = lst(p.holes),
      vis = trimVis(clampRect(arr(p.visible, 4), tpl) || [0, 0, tpl.w, tpl.h], hid), f = num(p.faces, 1, 2), isl = [], holes = [], i, r;
    for (i = 0; i < hid.length && i < 40; i++) { r = rectOf(hid[i]); if (r && r[2] > 0 && r[3] > 0 && (r = inter(r, vis))) isl.push(r); }
    for (i = 0; i < hl.length && i < 12; i++) {
      r = hl[i] && typeof hl[i] === "object" ? arr(hl[i], 3) || arr([hl[i].x, hl[i].y, hl[i].d || hl[i].dia || 0.25], 3) || arr(hl[i], 2) : null;
      if (r && r[0] >= 0 && r[0] <= tpl.w && r[1] >= 0 && r[1] <= tpl.h) holes.push([r[0], r[1], Math.max(0.1, Math.min(1.2, r[2] || 0.25))]);
    }
    if (f === null) f = /double|2[- ]?side|two/.test(str(p.sides)) ? 2 : /single|1[- ]?side|one/.test(str(p.sides)) ? 1 : two ? 2 : 1;
    return { tpl: tpl, vis: vis, isl: isl, holes: holes, faces: Math.round(f), flutes: str(p.flutes) };
  }
  function riderOf(o) {
    var r = o.rider, m, s;
    if (r === null || r === undefined || noneish(r)) return null;
    if (typeof r === "string" || typeof r === "number") {
      s = String(r).replace(/^\s+|\s+$/g, "");
      m = o.riders && typeof o.riders === "object" ? o.riders[s] || o.riders[s.replace(/\s+/g, "")] : null;
      if (m && typeof m === "object") return m;
      m = sizeOf(s);
      return m ? { tpl: { w: m[0], h: m[1] } } : {};
    }
    return typeof r === "object" ? r : null;
  }
  function normalize(o) {
    var key = keyOf(o.key), hw = obj(o.hardware), md = obj(hw.model), K = key.toUpperCase(),
      fam = famOf(o.family, key) || famOf(o.name, key) || famOf(hw.kind, key) || "yard",
      sp = o.sign && typeof o.sign === "object" ? o.sign : o, ks = sizeOf(key.replace(/^[A-Z]+-/i, "")) || [24, 18],
      S = piece(sp, ks, fam !== "yard" || /-2S(?![A-Z0-9])/i.test(key)),
      rp = fam === "yard" ? null : riderOf(o), R = rp ? piece(obj(rp), [S.tpl.w > 30 ? 36 : 24, 6], true) : null,
      order = str(o.order).toUpperCase(), size = [o.name, hw.kind, hw.post, hw.size, hw.type, md.post, md.size].map(str).join(" "),
      big = /large|big/.test(size) ? true : /small/.test(size) ? false : S.tpl.w > 24.5 || S.tpl.h > 36.5 || /^RP-36/.test(K),
      rpos = str(md.riderPos || hw.riderPos), base = MODEL[fam === "post" && big ? "postL" : fam], m = {}, hs, kk, x;
    if (!rpos && md.riderOnArm === false) rpos = "below";
    // a top-level faces / sides ("Single Sided" | "Double Sided") overrides sign.faces
    x = num(o.faces, 1, 2) || (/single|1[- ]?side/.test(str(o.sides)) ? 1 : /double|2[- ]?side/.test(str(o.sides)) ? 2 : null);
    if (x && sp !== o) S.faces = Math.round(x);
    rpos = /below|under/.test(rpos) ? "below" : "above";
    for (kk in base) if (base.hasOwnProperty(kk)) { x = num(md[kk], 0, 400); m[kk] = x !== null ? x : base[kk]; }
    if (fam === "post" && md.postHeight === undefined && num(hw.h, 40, 120)) m.postHeight = num(hw.h, 40, 120);
    // default holes: post signs hang from 2 holes near the top (16 in on centre on the small post, 24 in on the large);
    // A-frame signs hang from grommets in the top two corners
    if (fam === "post" && !S.holes.length) {
      hs = Math.min(big ? 24 : 16, S.tpl.w - 2) / 2;
      S.holes = [[S.tpl.w / 2 - hs, big ? 2 : 1.35, 0.25], [S.tpl.w / 2 + hs, big ? 2 : 1.35, 0.25]];
    }
    if (fam === "aframe" && !S.holes.length) S.holes = [[1, 1, 0.4], [S.tpl.w - 1, 1, 0.4]];
    x = sp.stakeEntry && arr(sp.stakeEntry.legsX, 2);
    return {
      key: key, fam: fam, sign: S, rider: R, order: order, big: big, rpos: rpos, m: m,
      legs: fam !== "yard" ? null : x && x[0] >= 0 && x[1] <= S.tpl.w && x[1] - x[0] >= 2 ? x : [S.tpl.w / 2 - m.legSpacing / 2, S.tpl.w / 2 + m.legSpacing / 2],
      stake: fam === "yard" && order !== "GO" && !noneish(o.stake),
      pennant: fam === "aframe" && order !== "GO" && (truthy(o.pennant) || truthy(hw.pennant)), // not sold with Sign Only
      fw: num(hw.w, 20, 60) || (fam === "frame" ? m.innerWidth + 2 * m.tube : 0),
      fh: num(hw.h, 30, 80) || m.legBottom || 0
    };
  }
  function geoKey(C) {
    var p = function (P) { return P ? [P.tpl.w, P.tpl.h, P.vis, P.isl, P.holes, P.faces] : 0; };
    return JSON.stringify([C.fam, p(C.sign), p(C.rider), C.big, C.rpos, C.stake, C.pennant, C.fw, C.fh, C.m, C.legs]);
  }
  function rng(seed) { return function () { seed = seed * 16807 % 2147483647; return seed / 2147483647; }; }

  /* ---------- viewer ---------- */
  function build(host, opts) {
    var THREE = root.THREE, doc = host.ownerDocument || document, win = doc.defaultView || root,
      bg = bgColor(opts.background), canvas = doc.createElement("canvas");
    canvas.setAttribute("aria-label", "3D preview of your real estate sign. Drag to turn it.");
    canvas.setAttribute("data-ardor-realestate3d", "init");
    canvas.style.cssText = "position:absolute;top:0;left:0;right:0;bottom:0;inset:0;width:100%;height:100%;display:block;touch-action:none;outline:none;cursor:grab;";
    var attrs = { alpha: false, antialias: true, depth: true, stencil: false, premultipliedAlpha: true, preserveDrawingBuffer: false },
      gl = null;
    try { gl = canvas.getContext("webgl2", attrs); } catch (e1) { gl = null; }
    if (!gl) try { gl = canvas.getContext("webgl", attrs) || canvas.getContext("experimental-webgl", attrs); } catch (e2) { gl = null; }
    if (!gl) return null;
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, context: gl, antialias: true, alpha: false, stencil: false, preserveDrawingBuffer: false });
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.NoToneMapping;
    renderer.setClearColor(new THREE.Color(bg), 1);
    try { if (win.getComputedStyle && win.getComputedStyle(host).position === "static") host.style.position = "relative"; } catch (e3) { }
    host.appendChild(canvas);

    var maxAniso = 1;
    try { maxAniso = renderer.capabilities.getMaxAnisotropy() || 1; } catch (e4) { maxAniso = 1; }
    var canMip = !!renderer.capabilities.isWebGL2, scene = new THREE.Scene(),
      camera = new THREE.PerspectiveCamera(FOV, 1, 1, 4000), disposed = false;
    scene.add(camera);

    function lin(hex) { var c = new THREE.Color(hex); c.convertSRGBToLinear(); return c; }
    // lights: soft sky/ground fill, a light that follows the camera (so every side reads), a fixed key and back fill
    var hemi = new THREE.HemisphereLight(lin("#ffffff"), lin("#c9c4ba"), 0.46);
    hemi.position.set(0, 1, 0);
    scene.add(hemi);
    var head = new THREE.DirectionalLight(0xffffff, 0.34);
    head.position.set(-0.3, 0.5, 1);
    camera.add(head); camera.add(head.target);
    var key = new THREE.DirectionalLight(0xffffff, 0.36), fill = new THREE.DirectionalLight(0xffffff, 0.26);
    key.position.set(-0.45, 0.55, 0.7); fill.position.set(0.4, 0.5, -0.75);
    scene.add(key); scene.add(fill);

    /* materials (kept for the life of the viewer) */
    // print material: uv 0..1 spans the piece's visible area; its texture is that area cropped out of the page
    function artMat() {
      var m = new THREE.MeshLambertMaterial({ color: 0xffffff });
      m.onBeforeCompile = function (sh) { // transparent print pixels read as white material
        sh.fragmentShader = sh.fragmentShader.replace("#include <map_fragment>", ["#ifdef USE_MAP",
          "  vec4 tc = texture2D( map, vUv );", "  tc.rgb = mix( vec3( 1.0 ), tc.rgb, tc.a );",
          "  diffuseColor.rgb *= tc.rgb;", "#endif"].join("\n"));
      };
      m.customProgramCacheKey = function () { return "ardorRealestateArt"; };
      return m;
    }
    var MAT = { front: artMat(), back: artMat(), "rider-front": artMat(), "rider-back": artMat() };
    function lam(hex) { return new THREE.MeshLambertMaterial({ color: lin(hex) }); }
    function metal(hex, shin, spec) { return new THREE.MeshPhongMaterial({ color: lin(hex), specular: lin(spec || "#4a4f55"), shininess: shin || 50 }); }
    var M = {
      pvc: metal("#f1f1ee", 16, "#2a2a2a"), black: metal("#1d1e21", 40, "#474b51"), wire: metal("#9ea4aa", 70, "#868c93"),
      steel: metal("#b9bec4", 80, "#8a9097"), plastic: metal("#18191b", 25, "#383b40"), coro: lam("#f5f5f2"), coroEdge: lam("#e2e2dd"),
      acm: lam("#f3f3f1"), acmEdge: metal("#c6cbd0", 60, "#80868d"), pole: metal("#f4f4f2", 30, "#505050")
    };
    var groundMat = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, depthWrite: false, toneMapped: false });

    function plainTexture(c) {
      var t = new THREE.CanvasTexture(c);
      t.encoding = THREE.sRGBEncoding;
      t.anisotropy = maxAniso;
      t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
      t.magFilter = THREE.LinearFilter;
      t.minFilter = canMip ? THREE.LinearMipmapLinearFilter : THREE.LinearFilter;
      t.generateMipmaps = canMip;
      return t;
    }
    var groundCv = doc.createElement("canvas");
    groundCv.width = groundCv.height = 1024;
    var groundTex = plainTexture(groundCv);
    groundMat.map = groundTex;
    var penCv = null, penTex = null, penMat = null, // the A-frame's open house pennant (made when first needed)
      scratch = null, scratchG = null; // small read-back canvas for hidden islands

    var input = {}, state = normalize({ key: "YS-24x18" }), builtKey = "", signRoot = null, builds = 0, geos = [], ground = null,
      ptsAll = [], ptsNear = [], cAll = new THREE.Vector3(), target = new THREE.Vector3(0, 20, 0), fitHome = 200,
      size = { w: 0, h: 0 }, faces = {}, fi;
    for (fi = 0; fi < FACES.length; fi++) faces[FACES[fi]] = { src: null, tex: null, ck: "", cv: doc.createElement("canvas") };

    /* ---------- textures ---------- */
    // Each face's VISIBLE rect is copied out of the template page into its own canvas, so hidden zones and bleed never
    // reach the GPU. Hidden islands still inside it are painted in the colour of the hardware that covers them, holes
    // are punched (grommets on the A-frame). With no canvas the face shows a plain "Your artwork goes here" print.
    function pieceOf(name) { return name.charAt(0) === "r" ? state.rider : state.sign; }
    function crop(name, force) {
      var f = faces[name], P = pieceOf(name), back = name.slice(-4) === "back", src = f.src;
      if (!P || (back && (P.faces < 2 || !src))) { if (f.tex) f.tex.dispose(); f.tex = null; f.ck = ""; return; }
      var v = P.vis, t = P.tpl, sx = src ? src.width / t.w : 0, sy = src ? src.height / t.h : 0, k = Math.min(1024 / Math.max(v[2], v[3]), 48),
        cw = src ? Math.max(2, Math.min(4096, Math.round(v[2] * sx))) : Math.max(8, Math.round(v[2] * k)),
        ch = src ? Math.max(2, Math.min(4096, Math.round(v[3] * sy))) : Math.max(8, Math.round(v[3] * k)),
        ck = JSON.stringify([v, t, src ? [src.width, src.height] : name, P.isl, P.holes, state.fam]);
      if (!force && f.tex && ck === f.ck) return;
      f.ck = ck;
      if (f.cv.width !== cw || f.cv.height !== ch || !f.tex) {
        f.cv.width = cw; f.cv.height = ch;
        if (f.tex) f.tex.dispose();
        f.tex = plainTexture(f.cv);
      } else f.tex.needsUpdate = true;
      var g = f.cv.getContext("2d");
      g.setTransform(1, 0, 0, 1, 0, 0);
      g.clearRect(0, 0, cw, ch);
      if (src) { // 1.5 source pixels in from each side, so the (anti-aliased) boundary pixel never gets in
        var w = v[2] * sx, h = v[3] * sy, ix = w > 24 ? 1.5 : 0, iy = h > 24 ? 1.5 : 0;
        try { g.drawImage(src, v[0] * sx + ix, v[1] * sy + iy, w - 2 * ix, h - 2 * iy, 0, 0, cw, ch); } catch (e) { }
      } else {
        var fs = Math.round(Math.min(cw * 0.068, ch * 0.2));
        g.fillStyle = "#ffffff"; g.fillRect(0, 0, cw, ch);
        g.fillStyle = "#a6abb2"; g.textAlign = "center"; g.textBaseline = "middle";
        g.font = "600 " + fs + "px Helvetica, Arial, sans-serif";
        g.fillText(name.charAt(0) === "r" ? "Your rider goes here" : "Your artwork goes here", cw / 2, ch * (name.charAt(0) === "r" ? 0.5 : 0.42));
      }
      marks(g, P, cw / v[2], ch / v[3], back);
    }
    // a hidden island is filled with the average colour of the print just around it (or the hardware colour)
    function patch(g, x, y, w, h, cw, ch) {
      var x0 = Math.max(0, Math.floor(x) - 2), y0 = Math.max(0, Math.floor(y) - 2), x1 = Math.min(cw, Math.ceil(x + w) + 2),
        y1 = Math.min(ch, Math.ceil(y + h) + 2), fill = COVER[state.fam];
      if (x1 <= x0 || y1 <= y0) return;
      try {
        var ax0 = Math.max(0, x0 - 3), ay0 = Math.max(0, y0 - 3), aw = Math.min(cw, x1 + 3) - ax0, ah = Math.min(ch, y1 + 3) - ay0, n = 0, s = [0, 0, 0], i, j, o, a;
        if (aw * ah < 250000 && (x1 - x0) * (y1 - y0) < 0.3 * cw * ch) {
          if (!scratch) { scratch = doc.createElement("canvas"); scratchG = scratch.getContext("2d", { willReadFrequently: true }); }
          scratch.width = aw; scratch.height = ah;
          scratchG.clearRect(0, 0, aw, ah);
          scratchG.drawImage(g.canvas, ax0, ay0, aw, ah, 0, 0, aw, ah);
          var d = scratchG.getImageData(0, 0, aw, ah).data;
          for (j = 0; j < ah; j++) for (i = 0; i < aw; i++) {
            if (ax0 + i >= x0 - 1 && ax0 + i < x1 + 1 && ay0 + j >= y0 - 1 && ay0 + j < y1 + 1) continue; // a 2 px ring, 1 px clear of the patch
            o = 4 * (j * aw + i); a = d[o + 3] / 255;
            s[0] += d[o] * a + 255 * (1 - a); s[1] += d[o + 1] * a + 255 * (1 - a); s[2] += d[o + 2] * a + 255 * (1 - a); n++;
          }
          if (n) fill = "rgb(" + Math.round(s[0] / n) + "," + Math.round(s[1] / n) + "," + Math.round(s[2] / n) + ")";
        }
      } catch (e) { fill = COVER[state.fam]; } // a cross-origin print cannot be read back
      g.fillStyle = fill; g.fillRect(x0, y0, x1 - x0, y1 - y0);
    }
    function marks(g, P, kx, ky, back) {
      var v = P.vis, W = P.tpl.w, cw = g.canvas.width, ch = g.canvas.height, i, r, x, y, d, k = (kx + ky) / 2;
      for (i = 0; i < P.isl.length; i++) {
        r = P.isl[i];
        patch(g, (r[0] - v[0]) * kx, (r[1] - v[1]) * ky, r[2] * kx, r[3] * ky, cw, ch);
        if (back) patch(g, (W - r[0] - r[2] - v[0]) * kx, (r[1] - v[1]) * ky, r[2] * kx, r[3] * ky, cw, ch);
      }
      for (i = 0; i < P.holes.length; i++) {
        r = P.holes[i]; x = ((back ? W - r[0] : r[0]) - v[0]) * kx; y = (r[1] - v[1]) * ky; d = r[2] / 2 * k;
        if (state.fam === "aframe") { // a metal grommet (filling the island around its hole, if there is one)
          var o = r[2] / 2 + 0.2, j, q;
          for (j = 0; j < P.isl.length; j++) {
            q = P.isl[j];
            if (r[0] > q[0] && r[0] < q[0] + q[2] && r[1] > q[1] && r[1] < q[1] + q[3]) o = Math.max(o, Math.min(q[2], q[3]) / 2 - 0.04);
          }
          g.beginPath(); g.arc(x, y, o * k, 0, PI * 2); g.fillStyle = "#b3b8be"; g.fill();
          g.lineWidth = Math.max(1, 0.05 * k); g.strokeStyle = "#7d838a"; g.stroke();
          g.beginPath(); g.arc(x, y, d + 0.07 * k, 0, PI * 2); g.strokeStyle = "#8d939a"; g.lineWidth = Math.max(1, 0.08 * k); g.stroke();
        }
        g.beginPath(); g.arc(x, y, d, 0, PI * 2); g.fillStyle = "#34363a"; g.fill();
      }
    }
    function setMap(m, t) { if (m.map !== t) { if (!m.map !== !t) m.needsUpdate = true; m.map = t; } }
    function bindTextures() {
      var f = faces.front.tex, rf = faces["rider-front"].tex;
      setMap(MAT.front, f); setMap(MAT.back, faces.back.tex || f); // 2 sided, no back canvas: the front art again
      setMap(MAT["rider-front"], rf); setMap(MAT["rider-back"], faces["rider-back"].tex || rf);
    }
    function cropAll(force) { for (var i = 0; i < FACES.length; i++) crop(FACES[i], force); bindTextures(); }

    var controls = new THREE.OrbitControls(camera, canvas);
    controls.enablePan = false;
    controls.enableDamping = true;
    controls.dampingFactor = 0.12;
    controls.rotateSpeed = 0.8;
    controls.zoomSpeed = 0.9;
    controls.minPolarAngle = PI / 2 - EL_MAX;
    controls.maxPolarAngle = PI / 2 - EL_MIN;

    /* ---------- geometry helpers ---------- */
    function V3(p) { return new THREE.Vector3(p[0], p[1], p[2]); }
    function addTo(G, geo, mat, x, y, z) {
      var m = new THREE.Mesh(geo, mat);
      m.position.set(x || 0, y || 0, z || 0);
      G.add(m); geos.push(geo);
      return m;
    }
    function boxAt(G, mat, w, h, d, x, y, z) { return addTo(G, new THREE.BoxGeometry(w, h, d), mat, x, y, z); }
    function rod(G, mat, r, a, b, seg) { // a thin cylinder from point a to point b
      var va = V3(a), vb = V3(b), m = addTo(G, new THREE.CylinderGeometry(r, r, va.distanceTo(vb), seg || 10), mat);
      m.position.copy(va).add(vb).multiplyScalar(0.5);
      m.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), vb.sub(va).normalize());
      return m;
    }
    function disposeGeos() { for (var i = 0; i < geos.length; i++) try { geos[i].dispose(); } catch (e) { } geos.length = 0; }
    // a polyline with rounded corners (radius rad) swept as one round tube: bent wire and rod frames
    function wire(G, mat, pts, r, rad) {
      var q = [V3(pts[0])], path = new THREE.CurvePath(), len = 0, i, k, t, u;
      for (i = 1; i < pts.length - 1; i++) {
        var b = V3(pts[i]), d1 = V3(pts[i - 1]).sub(b), d2 = V3(pts[i + 1]).sub(b), l1 = d1.length(), l2 = d2.length(),
          rr = Math.min(rad, l1 * 0.45, l2 * 0.45), p1 = b.clone().addScaledVector(d1, rr / l1), p2 = b.clone().addScaledVector(d2, rr / l2);
        for (k = 0; k <= 4; k++) {
          t = k / 4; u = 1 - t;
          q.push(new THREE.Vector3(u * u * p1.x + 2 * u * t * b.x + t * t * p2.x, u * u * p1.y + 2 * u * t * b.y + t * t * p2.y, u * u * p1.z + 2 * u * t * b.z + t * t * p2.z));
        }
      }
      q.push(V3(pts[pts.length - 1]));
      for (i = 1; i < q.length; i++) if (q[i].distanceTo(q[i - 1]) > 1e-4) { path.add(new THREE.LineCurve3(q[i - 1], q[i])); len += q[i].distanceTo(q[i - 1]); }
      return addTo(G, new THREE.TubeGeometry(path, Math.min(800, Math.ceil(len / 0.3) + 8), r, 8, false), mat);
    }
    // a closed wire loop (hook, ring, zip tie) at x from y0 (lowest point) to y1 (highest), half width hw, in the
    // y-z plane (through a sign hole) or the x-y plane (xy = true)
    function loop(G, mat, x, y0, y1, z, hw, tr, xy) {
      var pts = [], n = 6, i, a, yb = y0 + hw, yt = Math.max(yb + 0.02, y1 - hw);
      for (i = 0; i <= n; i++) { a = PI + PI * i / n; pts.push([hw * Math.cos(a), yb + hw * Math.sin(a)]); }
      for (i = 0; i <= n; i++) { a = PI * i / n; pts.push([hw * Math.cos(a), yt + hw * Math.sin(a)]); }
      var v = pts.map(function (p) { return xy ? new THREE.Vector3(x + p[0], p[1], z) : new THREE.Vector3(x, p[1], z + p[0]); });
      return addTo(G, new THREE.TubeGeometry(new THREE.CatmullRomCurve3(v, true), 30, tr, 6, true), mat);
    }
    // a printed piece: a thin slab (w x h x thick, top edge at yTop, centred on cx) whose front (+z) and back (-z)
    // carry the print. Their uvs map the visible rect to 0..1, so outside it the texture clamps to the visible edge colour
    // (the frame's lips cover that strip). The back reads correctly from behind; 1 sided pieces get a plain back.
    function slab(G, P, cx, yTop, thick, fm, bm, edge, plain) {
      var w = P.tpl.w, h = P.tpl.h, v = P.vis, g = new THREE.BoxGeometry(w, h, thick), uv = g.attributes.uv, i, x, y;
      for (i = 16; i < 24; i++) { // the +z and -z faces (4 vertices each)
        x = uv.getX(i) * w; y = (1 - uv.getY(i)) * h;
        uv.setXY(i, (x - v[0]) / v[2], 1 - (y - v[1]) / v[3]);
      }
      return addTo(G, g, [edge, edge, edge, edge, fm, P.faces === 2 ? bm : plain], cx, yTop - h / 2, 0);
    }
    function holeAt(P, i, cx, yTop) { var h = P.holes[i]; return [cx - P.tpl.w / 2 + h[0], yTop - h[1], h[2] / 2]; }

    /* ---------- the hardware ---------- */
    // Yard sign: 4 mm coroplast on a wire H-stake (10 x 30 in): its two legs run up into the flutes from the bottom edge,
    // the sign rests on the upper cross wire, the lower cross wire sits at the ground. Sign only: the sign stands on the ground.
    function buildYard(G, sh) {
      var C = state, S = C.sign, m = C.m, w = S.tpl.w, h = S.tpl.h, st = C.stake, r = Math.max(0.05, m.wireDia / 2),
        ys = st ? Math.max(2, m.totalHeight - m.insertIntoSign - m.inGround) : 0, lb = Math.max(0.6, ys - m.crossbarBelowSign),
        xa = -w / 2 + C.legs[0], xb = -w / 2 + C.legs[1];
      slab(G, S, 0, ys + h, 0.16, MAT.front, MAT.back, M.coroEdge, M.coro);
      if (st) {
        rod(G, M.wire, r, [xa, 0, 0], [xa, ys + 0.01, 0], 8); rod(G, M.wire, r, [xb, 0, 0], [xb, ys + 0.01, 0], 8); // (inside the flutes above)
        rod(G, M.wire, r, [xa, ys - r - 0.02, 0], [xb, ys - r - 0.02, 0], 8);
        rod(G, M.wire, r, [xa, lb, 0], [xb, lb, 0], 8);
        sh.push(["c", xa, 0, 0.3, 0, 0.45, 0.5], ["c", xb, 0, 0.3, 0, 0.45, 0.5], ["r", -w / 2, -1, w / 2, 1, 0.1, 9]);
      } else sh.push(["r", -w / 2, -0.12, w / 2, 0.12, 0.45, 0.8], ["r", -w / 2, -1.5, w / 2, 1.5, 0.12, 5]);
    }
    // Real estate post: white PVC post with a cap, the arm through its top, the double sided aluminium sign hanging from
    // the arm on eye screws and S-hooks through its 2 holes. The rider sits on top of the arm, held by small clips at its
    // bottom edge (its hidden islands), or hooks when it has holes; it hangs under the sign when the model says so.
    function buildPost(G, sh) {
      var C = state, S = C.sign, R = C.rider, m = C.m, w = S.tpl.w, h = S.tpl.h, P = m.postSize, H = Math.max(36, m.postHeight),
        aH = m.armSize, aT = Math.min(H - 0.5, Math.max(aH + 20, m.armTopFromGround)), gap = m.signGapFromPost, x0 = -P / 2 - m.armBackOverhang,
        cx = P / 2 + gap + w / 2, x1 = Math.max(x0 + m.armLength, cx + w / 2 + 1), aB = aT - aH, sTop = aB - m.signTopBelowArm,
        th = 0.12, i, p, q, rTop, rw, cl;
      boxAt(G, M.pvc, P, H, P, 0, H / 2, 0);
      boxAt(G, M.pvc, P + 0.5, 0.8, P + 0.5, 0, H + 0.3, 0); // cap
      boxAt(G, M.pvc, P + 0.15, 0.3, P + 0.15, 0, H + 0.85, 0);
      boxAt(G, M.pvc, x1 - x0, aH, aH, (x0 + x1) / 2, aT - aH / 2, 0); // arm
      boxAt(G, M.pvc, 0.4, aH + 0.3, aH + 0.3, x1 + 0.2, aT - aH / 2, 0);
      boxAt(G, M.pvc, 0.4, aH + 0.3, aH + 0.3, x0 - 0.2, aT - aH / 2, 0);
      slab(G, S, cx, sTop, th, MAT.front, MAT.back, M.acmEdge, M.acm);
      for (i = 0; i < S.holes.length; i++) { // eye screw under the arm + an S-hook through the hole
        p = holeAt(S, i, cx, sTop);
        rod(G, M.steel, 0.06, [p[0], aB + 0.3, 0], [p[0], aB - 0.2, 0], 6);
        loop(G, M.steel, p[0], aB - 0.8, aB - 0.15, 0, 0.26, 0.05, true);
        loop(G, M.steel, p[0], p[1] + p[2] - 0.12, Math.max(p[1] + 0.45, aB - 0.62), 0, 0.18, 0.05);
      }
      if (R) {
        rw = R.tpl.w;
        if (C.rpos === "below") {
          rTop = sTop - h - 1.6;
          q = R.holes.length ? R.holes : [[rw / 2 - Math.min(16, rw - 2) / 2, 0.6, 0.25], [rw / 2 + Math.min(16, rw - 2) / 2, 0.6, 0.25]];
          for (i = 0; i < q.length; i++) loop(G, M.steel, cx - rw / 2 + q[i][0], rTop - q[i][1] + q[i][2] / 2 - 0.12, sTop - h + 0.4, 0, 0.18, 0.05);
        } else {
          rTop = aT + 0.3 + R.tpl.h;
          for (i = 0; i < R.holes.length; i++) { p = holeAt(R, i, cx, rTop); loop(G, M.steel, p[0], aT - 0.2, Math.max(aT + 0.4, p[1] + p[2] * 0.3), 0, 0.17, 0.05); }
          // clips on the arm top grip the rider's bottom edge (over its hidden islands; 2 default clips otherwise)
          cl = R.isl.length || R.holes.length ? R.isl : [[rw / 2 - Math.min(rw > 30 ? 24 : 16, rw - 2) / 2 - 0.5, R.tpl.h - 0.75, 1, 0.75], [rw / 2 + Math.min(rw > 30 ? 24 : 16, rw - 2) / 2 - 0.5, R.tpl.h - 0.75, 1, 0.75]];
          for (i = 0; i < cl.length; i++) {
            q = cl[i];
            if (q[1] + q[3] < R.tpl.h - 1.5) continue; // only islands along the bottom edge are clips
            boxAt(G, M.steel, q[2] + 0.1, rTop - q[1] + 0.04 - (aT - 0.1), th + 0.16, cx - rw / 2 + q[0] + q[2] / 2, (rTop - q[1] + 0.04 + aT - 0.1) / 2, 0);
          }
        }
        slab(G, R, cx, rTop, th, MAT["rider-front"], MAT["rider-back"], M.acmEdge, M.acm);
      }
      sh.push(["r", -P / 2, -P / 2, P / 2, P / 2, 0.62, 1.2], ["r", -P / 2 - 2, -P / 2 - 2, P / 2 + 2, P / 2 + 2, 0.2, 5],
        ["r", x0, -2, x1, 2, 0.07, 16]);
    }
    // Real estate frame: black powder coated steel frame (25.25 x 43 in) with stake legs pushed into the ground. The
    // 24 x 18 sign drops into the top slot and the 24 x 6 rider into the slot under it; lips on both faces cover the
    // hidden edge of each piece, clips on the top bar, step tabs on the legs. Layout heights are measured from the top.
    function buildFrame(G, sh) {
      var C = state, S = C.sign, R = C.rider, m = C.m, w = S.tpl.w, h = S.tpl.h, T = Math.max(0.3, m.tube), D = T,
        xi = Math.max(m.innerWidth, w + 0.02, R ? R.tpl.w + 0.02 : 0) / 2, xo = Math.max(C.fw / 2, xi + 0.3),
        FH = Math.max(C.fh, m.lowBarY + T + 4), yT = FH - Math.min(m.sink, FH - m.lowBarY - T - 2), lz = 0.08 + 0.05, s, i, ct;
      function Y(v) { return yT - v; }
      var sTop = Y(m.signTop), mid = Y(m.midBarY), rTop = Y(m.riderTop), low = Y(m.lowBarY);
      for (s = -1; s <= 1; s += 2) {
        boxAt(G, M.black, xo - xi, yT, D, s * (xo + xi) / 2, yT / 2, 0); // uprights / legs
        boxAt(G, M.black, m.stepTabLen, 0.7, D, s * (xo + m.stepTabLen / 2), Math.max(0.5, Y(m.stepTabY)), 0); // step tabs
        sh.push(["r", s * xo - (xo - xi) - 0.4, -D / 2 - 0.4, s * xo + m.stepTabLen, D / 2 + 0.4, 0.42, 0.8]);
      }
      boxAt(G, M.black, 2 * xi, T, D, 0, yT - T / 2, 0);
      boxAt(G, M.black, 2 * xi, T, D, 0, mid - T / 2, 0);
      boxAt(G, M.black, 2 * xi, T, D, 0, low - T / 2, 0);
      function lips(P, top, yHi, yLo) { // flanges from the bars and uprights to the edge of the piece's visible area
        var v = P.vis, pw = P.tpl.w, vl = -pw / 2 + v[0], vr = -pw / 2 + v[0] + v[2], vt = top - v[1], vb = top - v[1] - v[3], k, z;
        for (k = -1; k <= 1; k += 2) {
          z = k * lz;
          if (vl > -xi + 0.01) boxAt(G, M.black, vl + xi, yHi - yLo, 0.08, (vl - xi) / 2, (yHi + yLo) / 2, z);
          if (vr < xi - 0.01) boxAt(G, M.black, xi - vr, yHi - yLo, 0.08, (vr + xi) / 2, (yHi + yLo) / 2, z);
          if (vt < yHi - 0.01) boxAt(G, M.black, 2 * xi, yHi - vt, 0.08, 0, (yHi + vt) / 2, z);
          if (vb > yLo + 0.01) boxAt(G, M.black, 2 * xi, vb - yLo, 0.08, 0, (vb + yLo) / 2, z);
        }
      }
      slab(G, S, 0, sTop, 0.16, MAT.front, MAT.back, M.coroEdge, M.coro);
      lips(S, sTop, yT - T, mid);
      if (R) {
        slab(G, R, 0, rTop, 0.16, MAT["rider-front"], MAT["rider-back"], M.coroEdge, M.coro);
        lips(R, rTop, mid - T, low);
      }
      ct = Math.min(1.2, Math.max(0.3, m.signTop + S.vis[1] - 0.06)); // spring clips on the top bar (front and back), above the visible area
      for (s = -1; s <= 1; s += 2) for (i = -1; i <= 1; i += 2) boxAt(G, M.steel, 1.1, ct + 0.05, 0.08, i * w / 4, yT + 0.05 - (ct + 0.05) / 2, s * (D / 2 + 0.04));
      sh.push(["r", -xo, -1.2, xo, 1.2, 0.1, 10]);
    }
    // Real estate A-frame: two hinged loops of black steel rod; the double sided sign hangs from the top bar on zip
    // ties through its top corner grommets, the rider stands in the clamp on the raised middle of the top bar (the clamp
    // covers the rider's bottom-centre island), the optional open house pennant flies from a pole at the left hinge.
    function buildAframe(G, sh) {
      var C = state, S = C.sign, R = C.rider, m = C.m, w = S.tpl.w, r = Math.max(0.06, m.wireDia / 2), AW = Math.max(m.topBarWidth, w + 2),
        AH = Math.max(m.heightToTopBar, S.tpl.h + 6), zb = m.footSpread / 2, hx = Math.max(1, Math.min(AW / 2 - 3, m.handleWidth / 2) - 1.3),
        hy = AH + m.handleRise, sTop = AH - m.signTopBelowTopBar, s, i, p, k, rb = hy + r + 0.12, cw = 3.6, ins = 0.4, cxo = 0, q;
      for (s = -1; s <= 1; s += 2) {
        wire(G, M.black, [[-AW / 2, AH, 0], [-AW / 2, r, s * zb], [AW / 2, r, s * zb], [AW / 2, AH, 0]], r, 1.4);
        k = addTo(G, new THREE.CylinderGeometry(r + 0.14, r + 0.14, 1.1, 12), M.black, s * AW / 2, AH, 0); // hinges
        k.rotation.z = PI / 2;
        sh.push(["r", -AW / 2, s * zb - 0.35, AW / 2, s * zb + 0.35, 0.42, 0.7]);
      }
      wire(G, M.black, [[-AW / 2, AH, 0], [-hx - 1.3, AH, 0], [-hx, hy, 0], [hx, hy, 0], [hx + 1.3, AH, 0], [AW / 2, AH, 0]], r, 0.9);
      if (R) for (i = 0; i < R.isl.length; i++) { // the clamp grips the rider over its bottom island
        q = R.isl[i];
        if (q[1] + q[3] >= R.tpl.h - 0.05 && q[2] * q[3] > 0.2) { cw = q[2] + 0.2; ins = q[3] + 0.06; cxo = -R.tpl.w / 2 + q[0] + q[2] / 2; break; }
      }
      boxAt(G, M.plastic, cw, rb + ins - (hy - r - 0.25), 0.9, cxo, (rb + ins + hy - r - 0.25) / 2, 0); // rider clamp
      k = addTo(G, new THREE.CylinderGeometry(0.22, 0.22, 0.3, 12), M.steel, cxo, hy + 0.2, 0.55);
      k.rotation.x = PI / 2;
      slab(G, S, 0, sTop, 0.16, MAT.front, MAT.back, M.coroEdge, M.coro);
      for (i = 0; i < S.holes.length; i++) { // zip ties through the grommets, around the top bar
        p = holeAt(S, i, 0, sTop);
        loop(G, M.plastic, p[0], p[1] + p[2] * 0.4 - 0.04, AH + r + 0.09, 0, r + 0.1, 0.045);
        boxAt(G, M.plastic, 0.22, 0.32, 0.14, p[0], AH - r - 0.3, r + 0.14);
      }
      if (R) slab(G, R, 0, rb + R.tpl.h, 0.16, MAT["rider-front"], MAT["rider-back"], M.coroEdge, M.coro);
      if (C.pennant) pennant(G, -AW / 2 - 0.5, AH, m);
      sh.push(["r", -AW / 2, -zb, AW / 2, zb, 0.1, 9]);
    }
    function pennant(G, px, AH, m) {
      if (!penMat) {
        penCv = doc.createElement("canvas"); penCv.width = 512; penCv.height = 288;
        var g = penCv.getContext("2d");
        g.fillStyle = "#e0251b"; g.fillRect(0, 0, 512, 288);
        g.fillStyle = "#ffffff"; g.textAlign = "center"; g.textBaseline = "middle"; g.font = "800 62px Helvetica, Arial, sans-serif";
        g.fillText("OPEN", 360, 112); g.fillText("HOUSE", 360, 176);
        penTex = plainTexture(penCv);
        penMat = new THREE.MeshLambertMaterial({ color: 0xffffff, map: penTex, side: THREE.DoubleSide });
      }
      var top = AH + Math.max(6, m.poleAboveTopBar), L = Math.max(4, m.flagW), F = Math.max(2, m.flagH), geo = new THREE.BufferGeometry(), k;
      rod(G, M.pole, 0.22, [px, AH - 4, 0], [px, top + 0.4, 0], 12);
      boxAt(G, M.plastic, 1.1, 1.3, 1.1, px + 0.25, AH, 0);
      // a single sided print: from behind it reads mirrored, as the real one does
      geo.setAttribute("position", new THREE.Float32BufferAttribute([px, top, 0, px - L, top - F / 2, 0, px, top - F, 0], 3));
      geo.setAttribute("normal", new THREE.Float32BufferAttribute([0, 0, 1, 0, 0, 1, 0, 0, 1], 3));
      geo.setAttribute("uv", new THREE.Float32BufferAttribute([1, 1, 0, 0.5, 1, 0], 2));
      k = addTo(G, geo, penMat);
      k.renderOrder = 1;
    }

    /* ---------- the ground: a soft disc with baked contact shadows, fading into the background ---------- */
    function paintShadows(g, X0, Z0, s, list) {
      var OFF = 4096, i, e;
      for (i = 0; i < list.length; i++) {
        e = list[i];
        g.save(); g.shadowColor = "rgba(24,24,20," + e[5] + ")"; g.shadowBlur = Math.max(1, e[6] * s); g.shadowOffsetX = OFF;
        g.fillStyle = "#000"; g.beginPath();
        if (e[0] === "c") g.arc((e[1] - X0) * s - OFF, (e[2] - Z0) * s, Math.max(0.5, e[3] * s), 0, PI * 2);
        else g.rect((e[1] - X0) * s - OFF, (e[2] - Z0) * s, (e[3] - e[1]) * s, (e[4] - e[2]) * s);
        g.fill(); g.restore();
      }
    }
    function paintGround(box, list) {
      var N = groundCv.width, g = groundCv.getContext("2d"), cx = (box.min.x + box.max.x) / 2, cz = (box.min.z + box.max.z) / 2,
        R = Math.max(box.max.x - box.min.x, box.max.z - box.min.z) * 0.62 + 30, s = N / (2 * R), rnd = rng(11), i;
      g.setTransform(1, 0, 0, 1, 0, 0);
      g.globalCompositeOperation = "source-over";
      g.shadowColor = "rgba(0,0,0,0)"; g.shadowBlur = 0;
      g.clearRect(0, 0, N, N);
      g.fillStyle = "#dad8d3"; g.fillRect(0, 0, N, N);
      for (i = 0; i < 7000; i++) {
        g.fillStyle = rnd() > 0.5 ? "rgba(255,255,255,0.35)" : "rgba(90,88,84,0.14)";
        g.fillRect(rnd() * N, rnd() * N, 1 + rnd() * 1.5, 1 + rnd() * 1.5);
      }
      paintShadows(g, cx - R, cz - R, s, list);
      var fade = g.createRadialGradient(N / 2, N / 2, 0, N / 2, N / 2, N / 2);
      fade.addColorStop(0, "rgba(0,0,0,1)"); fade.addColorStop(0.5, "rgba(0,0,0,1)"); fade.addColorStop(0.76, "rgba(0,0,0,0.5)");
      fade.addColorStop(0.96, "rgba(0,0,0,0)"); fade.addColorStop(1, "rgba(0,0,0,0)");
      g.globalCompositeOperation = "destination-in"; g.fillStyle = fade; g.fillRect(0, 0, N, N);
      g.globalCompositeOperation = "source-over";
      groundTex.needsUpdate = true;
      if (!ground) {
        ground = new THREE.Mesh(new THREE.PlaneGeometry(2, 2), groundMat);
        ground.rotation.x = -PI / 2; ground.renderOrder = -1;
        scene.add(ground);
      }
      ground.scale.set(R, R, 1);
      ground.position.set(cx, 0.02, cz);
    }

    function buildAll() {
      if (signRoot) { scene.remove(signRoot); disposeGeos(); }
      builds++;
      signRoot = new THREE.Group();
      scene.add(signRoot);
      var sh = [], f = state.fam;
      if (f === "post") buildPost(signRoot, sh);
      else if (f === "frame") buildFrame(signRoot, sh);
      else if (f === "aframe") buildAframe(signRoot, sh);
      else buildYard(signRoot, sh);
      signRoot.updateMatrixWorld(true);
      var box = new THREE.Box3().setFromObject(signRoot);
      paintGround(box, sh);
      var X0 = box.min.x, X1 = box.max.x, Z0 = box.min.z, Z1 = box.max.z, Y1 = box.max.y + 0.3,
        mg = Math.max(0.6, 0.03 * Math.max(Y1, X1 - X0)), i;
      X0 -= mg; X1 += mg; Z0 -= mg; Z1 += mg;
      ptsAll = []; ptsNear = [];
      cAll.set((X0 + X1) / 2, Y1 * 0.5, (Z0 + Z1) / 2);
      for (i = 0; i < 8; i++) {
        ptsAll.push(new THREE.Vector3(i & 1 ? X1 : X0, i & 2 ? Y1 : 0, i & 4 ? Z1 : Z0));
        ptsNear.push(new THREE.Vector3(cAll.x + (i & 1 ? 1 : -1) * (X1 - X0) * 0.17, cAll.y + (i & 2 ? 1 : -1) * Y1 * 0.17, cAll.z + (i & 4 ? 1 : -1) * (Z1 - Z0) * 0.17));
      }
      var big = Math.max(Y1, X1 - X0, Z1 - Z0);
      camera.near = Math.max(0.2, big / 300); camera.far = big * 30;
      camera.updateProjectionMatrix();
    }

    /* ---------- camera ---------- */
    var raf = 0, tween = null, backupT = 0;
    function now() { return win.performance && win.performance.now ? win.performance.now() : Date.now(); }
    function invalidate() {
      if (disposed) return;
      if (!raf) raf = win.requestAnimationFrame(frame);
      // a background tab does not run animation frames: draw anyway a little later
      if (!backupT) backupT = win.setTimeout(function () { backupT = 0; if (raf) { win.cancelAnimationFrame(raf); raf = 0; frame(); } }, 250);
    }
    function draw() { try { renderer.render(scene, camera); } catch (e) { } }
    function frame() {
      raf = 0;
      if (disposed || (!size.w && !measure())) return;
      var moving = !!tween;
      if (tween) stepTween();
      controls.update();
      holdInView();
      draw();
      if (tween || moving) invalidate();
    }
    function getSph() {
      var ox = camera.position.x - target.x, oy = camera.position.y - target.y, oz = camera.position.z - target.z,
        r = Math.sqrt(ox * ox + oy * oy + oz * oz) || 1;
      return { az: Math.atan2(ox, oz), el: Math.asin(Math.max(-1, Math.min(1, oy / r))), r: r };
    }
    function setSph(az, el, r) {
      var ce = Math.cos(el);
      camera.position.set(target.x + r * ce * Math.sin(az), target.y + r * Math.sin(el), target.z + r * ce * Math.cos(az));
      camera.lookAt(target);
    }
    function fitDistance(az, el, aspect, share, pts, c) {
      var tv = Math.tan(FOV * PI / 360), th = tv * (aspect || 1), ce = Math.cos(el), se = Math.sin(el), sa = Math.sin(az),
        ca = Math.cos(az), m = 1 / (share || 1), best = 1, i, x, y, z, cx, cy, cz, d;
      for (i = 0; i < pts.length; i++) {
        x = pts[i].x - c.x; y = pts[i].y - c.y; z = pts[i].z - c.z;
        cx = x * ca - z * sa; cy = -x * se * sa + y * ce - z * se * ca; cz = x * ce * sa + y * se + z * ce * ca;
        d = cz + Math.max(Math.abs(cx) * m / th, Math.abs(cy) * m / tv);
        if (d > best) best = d;
      }
      return best;
    }
    function aspectNow() { return size.w > 0 && size.h > 0 ? size.w / size.h : 1.3; }
    function farFor(az, el, asp) { return fitDistance(az, el, asp || aspectNow(), FILL_HOME, ptsAll, cAll); }
    function nearFor(az, el, asp) { return Math.min(farFor(az, el, asp) * 0.9, fitDistance(az, el, asp || aspectNow(), FILL_NEAR, ptsNear, cAll)); }
    function place(az, el, r) {
      target.copy(cAll); controls.target.copy(target);
      setSph(az, el, r);
    }
    function viewOf(name) {
      var v = typeof name === "string" && VIEWS.hasOwnProperty(name) ? VIEWS[name] : VIEWS.home;
      return { az: v[0], el: v[1] };
    }
    function updateLimits() {
      var s = getSph(), h = viewOf("home");
      fitHome = farFor(h.az, h.el);
      controls.minDistance = nearFor(s.az, s.el);
      controls.maxDistance = Math.max(fitDistance(0, 0.1, aspectNow(), FILL_FAR, ptsAll, cAll), fitHome * 1.3);
    }
    function clampR(r, az, el) { return Math.max(nearFor(az, el), Math.min(controls.maxDistance, r)); }
    function holdInView() {
      var s = getSph(), near = nearFor(s.az, s.el);
      controls.minDistance = near;
      if (!tween && s.r < near - 0.01) setSph(s.az, s.el, near);
    }
    function stepTween() {
      var t = (now() - tween.t0) / tween.ms;
      if (t >= 1) t = 1;
      var k = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      place(tween.a.az + (tween.b.az - tween.a.az) * k, tween.a.el + (tween.b.el - tween.a.el) * k, tween.a.r + (tween.b.r - tween.a.r) * k);
      if (t >= 1) tween = null;
    }
    var reduced = false;
    try { reduced = !!(win.matchMedia && win.matchMedia("(prefers-reduced-motion: reduce)").matches); } catch (e5) { reduced = false; }
    function tweenTo(az, el, r, ms) {
      var a = getSph(), d = az - a.az;
      while (d > PI) d -= PI * 2;
      while (d < -PI) d += PI * 2;
      tween = { a: a, b: { az: a.az + d, el: el, r: r }, t0: now(), ms: reduced ? 1 : ms };
      invalidate();
    }
    function measure() {
      var w = host.clientWidth | 0, h = host.clientHeight | 0;
      if (w < 2 || h < 2) return false;
      var pr = Math.min(2, Math.max(1, win.devicePixelRatio || 1));
      if (w === size.w && h === size.h && pr === renderer.getPixelRatio()) return false;
      var oldFit = fitHome, had = size.w > 0;
      size.w = w; size.h = h;
      renderer.setPixelRatio(pr); renderer.setSize(w, h, false);
      camera.aspect = w / h; camera.updateProjectionMatrix();
      updateLimits();
      var s = getSph();
      if (had && !tween) place(s.az, s.el, clampR(s.r * fitHome / oldFit, s.az, s.el));
      else if (had && tween) tween.b.r = tween.b.r * fitHome / oldFit;
      else { var hv = viewOf("home"); place(hv.az, hv.el, fitHome); }
      controls.update();
      return true;
    }
    function onControlsChange() { invalidate(); }
    function onControlsStart() { tween = null; canvas.style.cursor = "grabbing"; }
    function onControlsEnd() { canvas.style.cursor = "grab"; }
    controls.addEventListener("change", onControlsChange);
    controls.addEventListener("start", onControlsStart);
    controls.addEventListener("end", onControlsEnd);

    var FIELDS = ["key", "family", "name", "sign", "rider", "riders", "hardware", "stake", "pennant", "tpl", "visible", "hidden",
      "faces", "sides", "holes", "flutes", "order"];
    var api = {
      set: function (o) {
        if (disposed || !o || typeof o !== "object") return;
        var k, oldFit = fitHome, s = getSph(), first = !builtKey,
          newKey = o.key !== undefined && keyOf(o.key) !== keyOf(input.key);
        if (newKey || (o.family !== undefined && str(o.family) !== str(input.family))) // a new sign: forget the old one's details
          for (k = newKey ? 1 : 2; k < FIELDS.length - 1; k++) if (o[FIELDS[k]] === undefined) delete input[FIELDS[k]];
        for (k = 0; k < FIELDS.length; k++) if (o[FIELDS[k]] !== undefined) input[FIELDS[k]] = o[FIELDS[k]];
        state = normalize(input);
        var gk = geoKey(state);
        if (gk !== builtKey) {
          buildAll(); builtKey = gk;
          updateLimits();
          if (first) { var hv = viewOf("home"); place(hv.az, hv.el, fitHome); }
          else {
            if (tween) tween.b.r = tween.b.r * fitHome / oldFit;
            place(s.az, s.el, clampR(s.r * fitHome / oldFit, s.az, s.el));
          }
          controls.update();
        }
        cropAll(false);
        invalidate();
      },
      // face: "front" | "back" | "rider-front" | "rider-back"; cv: the whole template page as printed (null = none)
      setFace: function (face, cv) {
        if (disposed || !faces.hasOwnProperty(face)) return;
        faces[face].src = cv && cv.width > 0 && cv.height > 0 ? cv : null;
        crop(face, true); bindTextures(); invalidate();
      },
      refresh: function () { // after redrawing a canvas already passed (a new size is fine too)
        if (disposed) return;
        cropAll(true);
        invalidate();
      },
      view: function (name) {
        if (disposed) return;
        var v = viewOf(name);
        tweenTo(v.az, v.el, farFor(v.az, v.el), 560);
      },
      zoom: function (dir) {
        if (disposed) return;
        var s = tween ? tween.b : getSph(), r = clampR(s.r * Math.pow(0.8, dir > 0 ? 1 : -1), s.az, s.el);
        tweenTo(s.az, s.el, r, 240);
      },
      resize: function () {
        if (disposed) return;
        if (measure()) { if (raf) { win.cancelAnimationFrame(raf); raf = 0; } draw(); invalidate(); }
      },
      snapshot: function (w, h, viewName) {
        if (disposed) return null;
        var out = null, oldPR = renderer.getPixelRatio(), oldSize = renderer.getSize(new THREE.Vector2()), oldAspect = camera.aspect,
          oldPos = camera.position.clone(), oldTarget = target.clone(), s = getSph();
        try {
          var cap = Math.min(4096, renderer.capabilities.maxTextureSize || 4096);
          w = Math.max(16, Math.min(cap, Math.round(w || size.w || 800)));
          h = Math.max(16, Math.min(cap, Math.round(h || size.h || 600)));
          renderer.setPixelRatio(1); renderer.setSize(w, h, false);
          camera.aspect = w / h; camera.updateProjectionMatrix();
          if (typeof viewName === "string" && VIEWS.hasOwnProperty(viewName)) {
            var v = viewOf(viewName);
            place(v.az, v.el, farFor(v.az, v.el, w / h));
          } else {
            place(s.az, s.el, s.r * farFor(s.az, s.el, w / h) / farFor(s.az, s.el, oldAspect || 1));
          }
          renderer.render(scene, camera);
          out = doc.createElement("canvas"); out.width = w; out.height = h;
          var ctx = out.getContext("2d");
          ctx.fillStyle = bg; ctx.fillRect(0, 0, w, h); ctx.drawImage(canvas, 0, 0, w, h);
        } catch (e) { out = null; }
        try {
          renderer.setPixelRatio(oldPR); renderer.setSize(oldSize.x, oldSize.y, false);
          camera.aspect = oldAspect; camera.updateProjectionMatrix();
          target.copy(oldTarget); controls.target.copy(target); camera.position.copy(oldPos); camera.lookAt(target);
          renderer.render(scene, camera);
        } catch (e2) { }
        return out;
      },
      // extra (not in the contract): small debug numbers for testing
      stats: function () {
        if (disposed) return null;
        var m = renderer.info.memory, r = renderer.info.render, S = state.sign, R = state.rider;
        return { geometries: m.geometries, textures: m.textures, frame: r.frame, calls: r.calls, triangles: r.triangles,
          family: state.fam, key: state.key, order: state.order, faces: S.faces, visible: S.vis.slice(), holes: S.holes.length,
          rider: R ? R.tpl.w + "x" + R.tpl.h : null, riderFaces: R ? R.faces : 0, riderVisible: R ? R.vis.slice() : null,
          stake: state.stake, post: state.fam === "post" ? (state.big ? "large" : "small") : null, riderPos: R && state.fam === "post" ? state.rpos : null,
          pennant: state.pennant, builds: builds };
      },
      dispose: function () {
        if (disposed) return;
        disposed = true;
        if (raf) win.cancelAnimationFrame(raf);
        if (backupT) win.clearTimeout(backupT);
        raf = 0; backupT = 0; tween = null;
        try { if (ro) ro.disconnect(); } catch (e) { }
        win.removeEventListener("resize", onWinResize);
        doc.removeEventListener("visibilitychange", onVis);
        canvas.removeEventListener("webglcontextlost", onLost, false);
        canvas.removeEventListener("webglcontextrestored", onRestored, false);
        controls.removeEventListener("change", onControlsChange);
        controls.removeEventListener("start", onControlsStart);
        controls.removeEventListener("end", onControlsEnd);
        controls.dispose();
        disposeGeos();
        if (ground) ground.geometry.dispose();
        if (scratch) scratch.width = 1;
        var list = [groundMat, groundTex, penMat, penTex], k;
        for (k in M) if (M.hasOwnProperty(k)) list.push(M[k]);
        for (k in MAT) if (MAT.hasOwnProperty(k)) list.push(MAT[k]);
        for (k = 0; k < FACES.length; k++) { list.push(faces[FACES[k]].tex); faces[FACES[k]].tex = faces[FACES[k]].src = null; faces[FACES[k]].cv.width = 1; }
        for (k = 0; k < list.length; k++) try { if (list[k]) list[k].dispose(); } catch (e3) { }
        try { renderer.dispose(); renderer.forceContextLoss(); } catch (e4) { }
        if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      }
    };
    function onWinResize() { api.resize(); }
    function onLost(e) { e.preventDefault(); }
    function onRestored() { invalidate(); }
    function onVis() { if (!doc.hidden) invalidate(); }
    canvas.addEventListener("webglcontextlost", onLost, false);
    canvas.addEventListener("webglcontextrestored", onRestored, false);
    doc.addEventListener("visibilitychange", onVis);
    var ro = null;
    if (win.ResizeObserver) { ro = new win.ResizeObserver(function () { api.resize(); }); ro.observe(host); }
    win.addEventListener("resize", onWinResize);

    api.set({ key: "YS-24x18", family: "yard" });
    if (!measure()) controls.update();
    invalidate();
    canvas.setAttribute("data-ardor-realestate3d", "ready");
    return api;
  }

  root.ArdorRealestate3D = { create: create, version: "1.0.0" };
})(typeof window !== "undefined" ? window : this);
